export default __webpack_public_path__ + "static/grill-65b4152ea0e1ca10994301c5e7952762.jpg";